// This is a shim for the old location of this file
export * from "./form/validation";

export const alphabetAndNumbersRegex = /^[0-9a-zA-Z]+$/;

export const decimalRegex = /^\d*\.?\d*$/;
